import { Background } from '@appcharge/shared-ui';
import { Stack } from '@mui/material';
import { useMaintenanceMode } from '../../hooks/useMaintenanceMode';
import { StyledMaintenanceContent } from './style';

const LOGO_STYLE = { objectFit: 'contain' as const, maxWidth: '200px' };

const MaintenancePage = () => {
  const { sanitizedHtml, logo, fontColor, fontFamily, backgroundImageMobile, backgroundImageDesktop } =
    useMaintenanceMode();

  if (!sanitizedHtml?.trim()) return null;

  return (
    <Background
      backgroundImageMobile={backgroundImageMobile}
      backgroundImageDesktop={backgroundImageDesktop}
      isStore
    >
      <Stack alignItems="center" justifyContent="center" height="100vh" p={4} gap={3}>
        {logo && <img src={logo} alt="logo" style={LOGO_STYLE} />}
        <StyledMaintenanceContent
          fontFamily={fontFamily}
          fontColor={fontColor}
          dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
      </Stack>
    </Background>
  );
};

export default MaintenancePage;
